import React from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';

import { StyledBenefits } from './Benefits.styled';
import { ContentfulPageSection } from '~/types/types';

export const Benefits: React.FC<BenefitsProps> = ({
  sections,
  productName,
}) => {
  return (
    <>
      {sections.map(section => (
        <StyledBenefits key={section.id}>
          <article>
            <h3>{section.title}</h3>
            <p className="tagline">{productName}</p>
            <div
              dangerouslySetInnerHTML={{
                __html: section.description?.childMarkdownRemark?.html,
              }}
            />
            {section.media?.length && (
              <div
                className="mediaContent"
                dangerouslySetInnerHTML={{
                  __html:
                    section.media[0]?.description?.childMarkdownRemark?.html,
                }}
              />
            )}
          </article>

          {section.media?.[0]?.media && (
            <figure>
              <GatsbyImage
                image={section.media[0].media.gatsbyImageData}
                alt={section.media[0].media.title}
              />
            </figure>
          )}
        </StyledBenefits>
      ))}
    </>
  );
};

interface BenefitsProps {
  sections: ContentfulPageSection[];
  productName: string;
}
